import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import baseTranslation from '../../../../assets/i18n/en_devel.json';
import { CopycatModule } from '../../../common/copycat/copycate.module';
import { WEBLATE_COMPONENT_NAME } from '../../../constants';
import { DomainRecordsTableComponent } from './domain-records-table.component';
import { DomainRecordsTableRowComponent } from './domain-records-table.row';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatIconModule,
    CopycatModule,
  ],
  declarations: [DomainRecordsTableComponent, DomainRecordsTableRowComponent],
  exports: [DomainRecordsTableComponent],
})
export class DomainRecordsTableModule {}
